export default {
      id: "ic_account_logout-usage",
      viewBox: "0 0 15 17",
      url: "/" + "images/icons.3.109.2.svg#ic_account_logout-usage",
      toString: function () {
        return this.url;
      }
    }